import {
  WebsiteContainer,
  WebsiteEyebrow,
  WebsiteGlow,
  WebsiteHeading,
  WebsiteSection,
  WebsiteStoreBadges,
  WebsiteText,
} from "@-/dev.improve.haniverse.components.website";
import { LandingAndroidFrame, LandingIphoneFrame } from "#landing-device-frames";
import { LandingQrCodeCard } from "#landing-download-qr-code";
import { LANDING_DOWNLOAD_SECTION_ID } from "#landing-download-section-id";
import { LANDING_SCREENSHOTS } from "#landing-screenshots";

/**
 * The closing call to action and the target of every "Get the app" link on desktop: both phones
 * side by side, both badges, and the QR code.
 */
export function LandingDownloadSection() {
  return (
    <WebsiteSection
      className="overflow-hidden pt-20 sm:pt-28 lg:pt-32"
      id={LANDING_DOWNLOAD_SECTION_ID}
      spacing="none"
      tone="ink"
    >
      <WebsiteGlow
        blur="xl"
        className="-bottom-40 left-1/2 h-[30rem] w-[60rem] -translate-x-1/2"
        tone="strong"
      />
      <WebsiteContainer className="grid items-end gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-20">
        <div className="pb-0 lg:pb-32">
          <WebsiteEyebrow>Get Haniverse</WebsiteEyebrow>
          <WebsiteHeading className="mt-4 max-w-[13ch]" level={2}>
            Your first story is a minute away.
          </WebsiteHeading>
          <WebsiteText className="mt-5 max-w-[30rem]" size="lead">
            Start with a single stroke and build from there. Free to start on iPhone and Android,
            with your progress synced between devices.
          </WebsiteText>
          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-5">
            <WebsiteStoreBadges />
            <LandingQrCodeCard className="hidden lg:flex" />
          </div>
        </div>

        <div className="relative mx-auto flex w-full max-w-[34rem] items-end justify-center gap-[5%]">
          <LandingAndroidFrame
            className="relative mb-[-8%] w-[44%] translate-y-[6%]"
            screenshot={LANDING_SCREENSHOTS.androidMnemonic}
          />
          <LandingIphoneFrame
            className="relative mb-[-8%] w-[46%]"
            screenshot={LANDING_SCREENSHOTS.iosSearch}
          />
        </div>
      </WebsiteContainer>
    </WebsiteSection>
  );
}
